// extracted by mini-css-extract-plugin
export default {"card-container":"SkillCard_card-container__hb5av"};